import { memo } from 'react';

import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button, Flex, Typography } from 'antd';
import cn from 'classnames';
import dayjs from 'dayjs';

import cls from './trading-platform-month-switcher.module.css';

interface TradingPlatformMonthSwitcherProps {
    value: dayjs.Dayjs;
    onNextMonth: VoidFunction;
    onPrevMonth: VoidFunction;
    isLoading: boolean;
}

export const TradingPlatformMonthSwitcher = memo(
    (props: TradingPlatformMonthSwitcherProps) => {
        const { value, onPrevMonth, onNextMonth, isLoading } = props;

        return (
            <Flex
                align="center"
                className={cls.root}
                gap={8}
            >
                <Button
                    disabled={isLoading}
                    icon={<LeftOutlined />}
                    onClick={onPrevMonth}
                    size="small"
                    type="text"
                />
                <Typography.Title
                    className={cn(cls.title, { [cls.disabled]: isLoading })}
                    level={5}
                >
                    {value.format('MMMM YYYY')}
                </Typography.Title>
                <Button
                    disabled={isLoading}
                    icon={<RightOutlined />}
                    onClick={onNextMonth}
                    size="small"
                    type="text"
                />
            </Flex>
        );
    },
);

TradingPlatformMonthSwitcher.displayName = 'TradingPlatformMonthSwitcher';
